






import { Component, Prop, Vue } from 'vue-property-decorator'
import Pill from '../Pill/Pill.vue'
import { TestStatus } from '@shared/types/database'

@Component({ components: { Pill } })

export default class TestStatusList extends Vue {
  @Prop({ required: true }) readonly statusCount!: Record<TestStatus, number>
}
